import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin'
import { create } from 'zustand'
import { createJSONStorage, persist, StateStorage } from 'zustand/middleware'

import { ICredentialsModel } from '@apps-common/types/portal/credentials'

const storage: StateStorage = {
  getItem: async (name: string): Promise<string | null> => {
    const result = await SecureStoragePlugin.get({ key: name })

    return result?.value || null
  },
  setItem: async (name: string, value: string): Promise<void> => {
    await SecureStoragePlugin.set({ key: name, value })
  },
  removeItem: async (name: string): Promise<void> => {
    await SecureStoragePlugin.remove({ key: name })
  }
}

export interface ISecureStorage {
  credentials: ICredentialsModel | null
  setCredentials: (credentials: ICredentialsModel) => void
}

export const useSecureStorage = create<ISecureStorage, [['zustand/persist', unknown]]>(
  persist(
    (set, get) => ({
      credentials: null,
      setCredentials: (credentials: ICredentialsModel) => set({ credentials })
    }),
    {
      name: 'secure-storage',
      storage: createJSONStorage(() => storage)
    }
  )
)
